var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 11.6833V14.63C15.7501 14.841 15.6702 15.0441 15.5263 15.1985C15.3825 15.3528 15.1855 15.4469 14.975 15.4617C14.6108 15.4867 14.3133 15.5 14.0833 15.5C6.71917 15.5 0.75 9.53083 0.75 2.16667C0.75 1.93667 0.7625 1.63917 0.788333 1.275C0.803102 1.06454 0.897151 0.867509 1.0515 0.723674C1.20585 0.579839 1.40902 0.499905 1.62 0.5H4.56667C4.67003 0.499896 4.76975 0.538216 4.84644 0.607517C4.92313 0.676818 4.97133 0.772152 4.98167 0.875C5.00083 1.06667 5.01833 1.21917 5.035 1.335C5.20061 2.49077 5.54 3.61486 6.04167 4.66917C6.12083 4.83583 6.06917 5.035 5.91917 5.14167L4.12083 6.42667C5.22038 8.98871 7.26212 11.0305 9.82417 12.13L11.1075 10.335C11.16 10.2617 11.2365 10.2091 11.3237 10.1864C11.411 10.1637 11.5035 10.1723 11.585 10.2108C12.6392 10.7116 13.763 11.0501 14.9183 11.215C15.0342 11.2317 15.1867 11.25 15.3767 11.2683C15.4794 11.2789 15.5745 11.3271 15.6436 11.4038C15.7128 11.4805 15.751 11.5801 15.7508 11.6833H15.75Z",
    fill: "#01295F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelIcon);
export default __webpack_public_path__ + "static/media/TelIcon.9b213410d273de98462cc5933cb363dd.svg";
export { ForwardRef as ReactComponent };